import css from './ListingPage.module.css';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import React from 'react';
import { getListingCategory } from '../EditListingPage/listingTypeUtils';

const ShareButton = ({ listing, rootClassName }) => {
  const listingCategory = getListingCategory(listing);

  const classname = rootClassName ? rootClassName : css.icon;

  const onShare = () => {
    if ('share' in navigator) {
      navigator
        .share({
          title: `Check out this nearby ${listingCategory?.label?.toLowerCase() ||
            'sports & fitness activity'} I found on FootFall: `,
          text:
            'Discover nearby gyms, sports clubs, personal trainers & classes on FootFall. Check out this one: ',
          url: window.location.href,
        })
        .catch(console.error);
    } else {
      console.log('provide fallback share');
    }
  };

  return (
    <button className={classname} onClick={onShare}>
      <IosShareRoundedIcon />
      {!rootClassName && <span className={css.iconLabel}>Share</span>}
    </button>
  );
};

export default ShareButton;
